import Modal from "components/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import SelectBox from "components/SelectBox";
import useTranslation from "hooks/useTranslation";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { blockUserStart } from "redux/chats/chats.actions";
import { getNotifMsg } from "utils/message";

const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;
const getLocale = ({ settingsData }) => settingsData.locale;

function BlockUserModal({
  showBlockUserModal,
  setShowBlockUserModal,
  selectedBlockOption,
  setSelectedBlockOption,
}) {
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();
  const dispatch = useDispatch();

  const selectedConversation = useSelector(getSelectedConversation);
  const locale = useSelector(getLocale);

  let blockUserOptions = [
    {
      title: t("MODAL").BAN_FOR_ONE_ALWAYS,
      value: "0",
    },
    {
      title: t("MODAL").BAN_FOR_ONE_DAY,
      value: "1",
    },
    {
      title: t("MODAL").BAN_FOR_ONE_WEEK,
      value: "7",
    },
    {
      title: t("MODAL").BAN_FOR_ONE_MONTH,
      value: "30",
    },
  ];

  const handleBlockUser = () => {
    if (selectedBlockOption) {
      const formData = {
        key: "blackList",
        end: selectedBlockOption ? selectedBlockOption : "",
        id: selectedConversation.user.id,
        ip: selectedConversation.user.ip,
      };
      setShowBlockUserModal(false);
      dispatch(blockUserStart(formData));
    } else {
      toast.error(getNotifMsg("CHOOSE_RANGE_FOR_BLOCK", locale));
    }
  };

  return (
    <Modal
      visible={showBlockUserModal}
      setVisibility={setShowBlockUserModal}
      className="confirmation-modal"
    >
      <ModalBody>
        <div>
          <div className="conv__body__header_block_user_modal_title">
            {t("MODAL").ADD_TO_BLACK_LIST_TITLE}
          </div>
          <div className="conv__body__header_block_user_modal_select">
            <SelectBox
              title={t("MODAL").ADD_TO_BLACK_LIST_FOR}
              options={blockUserOptions}
              value={selectedBlockOption}
              onChange={(e) => setSelectedBlockOption(e.target.value)}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="modal__container__footer__left">
          <button
            onClick={() => setShowBlockUserModal(false)}
            className="btn btn-tertiary"
            id="closeModal"
          >
            {t("CANCEL")}
          </button>
          <button onClick={() => handleBlockUser()} className="btn btn-primary">
            {t("CONFIRM")}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default BlockUserModal;
